import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Form, Formik } from "formik";
import RecoverPasswordValidationSchema from "./RecoverPasswordValidationSchema";
import RecoverPasswordInitialValues from "./RecoverPasswordInitialValues";
import SubmitButton from "../buttons/SubmitButton";
import CancelButton from "../buttons/CancelButton";
import { useNavigate } from "react-router-dom";
import OutlinedTextField from "../../../../../components/formFields/OutlinedTextField";
import HelpTitle from "../HelpTitle";
import HelpText from "../HelpText";
import {
  sendNewPassword,
  changePassword,
  getAccount,
} from "../../../../../api/accountApi";
import ErrorToast from "../../../../../components/toasts/ErrorToast";

const labelStyle = {
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "142%",
  letterSpacing: "0.005em",
  color: "#4D4D4D",
  marginLeft: "56px",
  marginBottom: "10px",
};

type Props = {
  submitButtonRedirect: string;
  submitButtonText: string;
  cancelButtonRedirect: string;
  labelNewPasswordText: string;
  passwordKey: string;
  email: string;
  isChangePassword: boolean;
};

export default function RecoverPasswordForm(props: Props) {
  const [email, setEmail] = useState("");
  const [dataToast, setDataToast] = useState({ title: "", message: "" });

  useEffect(() => {
    props.isChangePassword &&
      getAccount().then((response) => setEmail(response.data.login));
  }, []);

  const handleSubmit = (values: any, actions: any) => {
    if (values.password.indexOf(" ") !== -1) {
      actions.setFieldError(
        "password",
        "La contraseña no puede contener espacios blancos"
      );
      actions.setSubmitting(false);
    } else if (values.password === values.actualPassword) {
      actions.setFieldError(
        "password",
        "La contraseña no puede ser igual a la actual"
      );
      actions.setSubmitting(false);
    } else {
      values.actualPassword
        ? changePass(values.actualPassword, values.password, actions)
        : sendPassword(values.password);
    }
  };

  const sendPassword = (password: string) => {
    sendNewPassword({ key: props.passwordKey, newPassword: password }).then(
      () => routeChangeSuccess()
    );
  };

  const changePass = (
    currentPassword: string,
    newPassword: string,
    actions: any
  ) => {
    changePassword({ currentPassword, newPassword })
      .then((resp) => {
        if (resp?.status === 200) {
          setDataToast({ title: "", message: "" });
          routeChangeSuccess();
        } else {
          setDataToast({
            title: "Error",
            message: "La contraseña actual es incorrecta",
          });
        }
        actions.setSubmitting(false);
      })
      .catch(() => {
        setDataToast({
          title: "Error",
          message: "No se pudo procesar la información.",
        });
        actions.setSubmitting(false);
      })
      .finally();
  };

  let navigate = useNavigate();
  const routeChangeSuccess = () => {
    navigate(props.submitButtonRedirect, { replace: true });
  };

  return (
    <Formik
      initialValues={RecoverPasswordInitialValues}
      onSubmit={handleSubmit}
      validationSchema={() =>
        RecoverPasswordValidationSchema(props.isChangePassword)
      }
      isInitialValid={false}
    >
      {({ isSubmitting, isValid }: any) => (
        <Form id="register">
          <HelpTitle
            email={props.isChangePassword ? email : props.email}
          ></HelpTitle>
          <Box sx={{ margin: "20px 0" }}>
            <HelpText></HelpText>
          </Box>
          <Box sx={{ margin: "0 5%" }}>
            {props.isChangePassword && (
              <Box>
                <Box style={labelStyle}>Ingrese la contraseña actual</Box>
                <Box sx={{ display: "flex" }}>
                  <OutlinedTextField
                    className="field-password"
                    name="actualPassword"
                    password
                    placeholder="**********"
                    fullWidth={true}
                  />
                </Box>
              </Box>
            )}
            <Box style={labelStyle}>{props.labelNewPasswordText}</Box>
            <Box sx={{ display: "flex" }}>
              <OutlinedTextField
                className="field-password"
                name="password"
                password
                placeholder="**********"
                autocomplete="current-password"
                fullWidth={true}
              />
            </Box>
            <Box style={labelStyle}>Repita contraseña</Box>
            <Box sx={{ display: "flex" }}>
              <OutlinedTextField
                className="field-password"
                name="passwordRepeat"
                password
                placeholder="**********"
                fullWidth={true}
              />
            </Box>
            {dataToast?.title?.length > 0 && (
              <ErrorToast
                title={dataToast.title}
                message={dataToast.message}
              ></ErrorToast>
            )}
          </Box>

          <Box className="centered" style={{ padding: "17px 0 27px" }}>
            <CancelButton redirect={props.cancelButtonRedirect}></CancelButton>
            <SubmitButton
              isValid={isValid}
              isSubmitting={isSubmitting}
              text={props.submitButtonText}
            ></SubmitButton>
          </Box>
        </Form>
      )}
    </Formik>
  );
}
